import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const returnExchangeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getReturnExchangeListings: builder.mutation({
      query: ({ body }) => ({
        url: `${END_POINTS.returnExchangeListings}`,
        method: "POST",
        body,
      }),
    }),

    deleteReturnExchange: builder.mutation({
      query: ({ id }) => ({
        url: `${END_POINTS.deletById}${id}/`,
        method: "DELETE",
      }),
    }),

    updateReturnExchangeStatus: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.orderStatusUpdate}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    getReturnExchangeById: builder.query({
      query: ({ id, type }) => ({
        url: `${END_POINTS.exchangeById}/${id}/${type}/`,
        method: "GET",
      }),
    }),

    exchangeAcceptReject: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.exchangeAcceptReject}${id}/`,
        method: "POST",
        body,
      }),
    }),

    returnAcceptReject: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.returnAcceptReject}${id}/`,
        method: "POST",
        body,
      }),
    }),

    setRefundAmount: builder.mutation({
      query: ({ body, id, type }) => ({
        url: `${END_POINTS.setRefundAmount}${id}/${type}/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetReturnExchangeListingsMutation,
  useLazyGetReturnExchangeByIdQuery,
  useDeleteReturnExchangeMutation,
  useUpdateReturnExchangeStatusMutation,
  useExchangeAcceptRejectMutation,
  useReturnAcceptRejectMutation,
  useSetRefundAmountMutation,
} = returnExchangeApi;
